import history from '../../util/history'

const toAutoActionTabView = (basePath, reservationId) => {
  history.replace(`${basePath}/${reservationId}/auto_action_log`)

  return true
}

export default toAutoActionTabView
